import styled from 'styled-components';

export const TooltipTitle = styled.div`
  white-space: pre-line;
`;
